export default __webpack_public_path__ + "static/media/moonbeam.97f89745.webp";